import { Controller } from "stimulus"

// #1996: Schema toevoegen: wisselen tussen Templates en Periodisering en het
// venster sluiten. De lijst zelf is schema_lijst_controller.
export default class extends Controller {
  static targets = ["tab", "pane"]

  kies(event) {
    const soort = event.currentTarget.dataset.soort
    this.tabTargets.forEach((tab) => {
      const actief = tab.dataset.soort === soort
      tab.classList.toggle("is-actief", actief)
      tab.setAttribute("aria-selected", actief ? "true" : "false")
    })
    this.paneTargets.forEach((pane) => {
      pane.hidden = pane.dataset.soort !== soort
      if (!pane.hidden) pane.dispatchEvent(new CustomEvent("schema-lijst:zichtbaar"))
    })
  }

  sluit() {
    this.element.closest("dialog")?.close()
  }
}
